import React, { useEffect, useState } from 'react';

export const BEFORE_REFRESH = 'mekandapro:before-refresh';
const mainPath = (value, type = 'js') => {
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    const match = type === 'css' ? /^\/static\/css\/main\.[\w-]+\.css$/
      : /^\/static\/js\/main\.[\w-]+\.js$/;
    return match.test(url.pathname) ? url.pathname : null;
  } catch { return null; }
};
export default function UpdateNotice({ reload = () => window.location.reload() }) {
  const [available, setAvailable] = useState(false), [dismissed, setDismissed] = useState(false), [error, setError] = useState('');
  useEffect(() => {
    const loadedJs = [...document.scripts].map(script => mainPath(script.src, 'js')).find(Boolean);
    const loadedCss = [...document.querySelectorAll('link[rel="stylesheet"]')]
      .map(link => mainPath(link.href, 'css')).find(Boolean);
    if (!loadedJs && !loadedCss) return undefined; // Development/test bundles have no release identity.
    let stopped = false, controller = null;
    const check = async () => {
      if (document.visibilityState === 'hidden' || controller) return;
      controller = new AbortController();
      const timeout = setTimeout(() => controller?.abort(), 8000);
      try {
        const response = await fetch(`/asset-manifest.json?update=${Date.now()}`, { cache: 'no-store', signal: controller.signal });
        if (!response.ok) return;
        const manifest = await response.json();
        const currentJs = mainPath(manifest.files?.['main.js'], 'js');
        const currentCss = mainPath(manifest.files?.['main.css'], 'css');
        const jsChanged = !!(loadedJs && currentJs && currentJs !== loadedJs);
        const cssChanged = !!(loadedCss && currentCss && currentCss !== loadedCss);
        if (!stopped && (jsChanged || cssChanged)) setAvailable(true);
      } catch { /* An offline version check must never block the workspace. */ }
      finally { clearTimeout(timeout); controller = null; }
    };
    check();
    const timer = setInterval(check, 60000);
    window.addEventListener('focus', check); document.addEventListener('visibilitychange', check);
    return () => { stopped = true; clearInterval(timer); controller?.abort(); window.removeEventListener('focus', check); document.removeEventListener('visibilitychange', check); };
  }, []);
  if (!available || dismissed) return null;
  return <aside className="app-update-notice" aria-label="Uygulama güncellemesi">
    <p role="status">Yeni sürüm hazır. Kaydetmediğin form bilgilerini önce kaydet.</p>
    {error && <p role="alert">{error}</p>}
    <div><button className="action-secondary" onClick={() => setDismissed(true)}>Sonra</button>
      <button className="action-primary" onClick={() => {
        if (!window.dispatchEvent(new Event(BEFORE_REFRESH, { cancelable: true }))) {
          setError('Şu an yenilenemiyor. Devam eden işlemi tamamla; taslağın kaydedilemiyorsa metni kopyala.'); return;
        }
        reload();
      }}>Güncelle</button></div>
  </aside>;
}
